import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import useBreadcrumbs from "../../../utils/hooks/useBreadcrumbs";
import { FaUserFriends } from "react-icons/fa";
import ParentAPI from "../../../services/api/ParentService";
import { NotifyContext } from "../../../context/notifyContext";
import Alert from "../../../UI/Alert/Alert";

export default function ParentDetails() {
  const { id } = useParams<{ id: string }>();
  const notify = useContext(NotifyContext);
  const [parent, setParent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useBreadcrumbs([
    { label: "Parents", icon: <FaUserFriends />, is_link: true, href: "/app/parents" },
    { label: "Détail", is_link: false },
  ]);

  useEffect(() => {
    if (!id) return;
    ParentAPI.get_parent(Number(id))
      .then((res: any) => res?.data)
      .then((data: any) => {
        setParent(data?.parent);
        setError("");
      })
      .catch((err: any) => {
        setError(err?.message || err || "Erreur");
        notify(err?.message || err, "error");
      })
      .finally(() => setLoading(false));
  }, [id, notify]);

  if (loading) {
    return (
      <div className="flex justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }
  if (error || !parent) {
    return (
      <div className="p-4">
        {error && <Alert color="error">{error}</Alert>}
        <Link to="/app/parents" className="text-primary-600 underline">
          Retour à la liste
        </Link>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-2xl">
      <div className="bg-white rounded shadow p-6 space-y-4">
        <h2 className="text-xl font-semibold">
          {parent.first_name} {parent.last_name}
        </h2>
        <p>
          <span className="font-medium">Email :</span> {parent.email}
        </p>
        <p>
          <span className="font-medium">Téléphone :</span> {parent.phone_number || "-"}
        </p>
        <p>
          <span className="font-medium">Civilité :</span> {parent.civility || "-"}
        </p>
        {(parent.address_line_1 || parent.city || parent.zip_code || parent.country) && (
          <div className="border-t pt-4 mt-4">
            <p className="font-medium mb-2">Adresse</p>
            {parent.address_line_1 && <p>{parent.address_line_1}</p>}
            <p>
              {[parent.zip_code, parent.city].filter(Boolean).join(" ")}
              {parent.country ? `, ${parent.country}` : ""}
            </p>
          </div>
        )}
        <p>
          <span className="font-medium">Statut :</span> {parent.user_status || "-"}
        </p>
        <p>
          <span className="font-medium">Inscrit le :</span>{" "}
          {parent.created_at
            ? new Date(parent.created_at).toLocaleString()
            : "-"}
        </p>
      </div>
      <Link to="/app/parents" className="inline-block mt-4 text-primary-600 underline">
        Retour à la liste des parents
      </Link>
    </div>
  );
}
